
import { Sofortbestellung } from "@/entities/common/bestellung_pending"
import BestaetigenLogic from "@/logic/bestellung_neu/bestaetigen_logic"
import Vue from "vue"
import Component, { mixins } from "vue-class-component"
import { Prop, PropSync } from "vue-property-decorator"
import Calculator from "../mixins/Calculator.vue"

@Component
export default class BestaetigenSofort extends mixins(Calculator) {
  @PropSync("data")
  sofortbestellung: Sofortbestellung

  @Prop()
  logic: BestaetigenLogic

  mounted() {}
}
